import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { COLORS } from '@lemonade-hq/tokens';
import Image from 'next/image';
import styled, { css, type CSSProperties } from 'styled-components';

interface SectionProps {
  darkBackground: boolean;
  contain: CSSProperties['contain'];
}

export const Section = styled(Flex).attrs({
  as: 'section',
})<SectionProps>`
  flex-direction: column;
  align-items: center;
  background-color: ${({ darkBackground }: SectionProps) => (darkBackground ? COLORS.cloud : COLORS.white)};
  ${({ contain }) =>
    contain != null &&
    css`
      contain: ${contain};
    `}
`;

export const CoverageItem = styled(Flex)`
  position: relative;
  width: 100%;
  align-items: center;
  flex-direction: column;

  ${MEDIA_QUERIES.tablet`
        align-self: flex-end;

        p {
            white-space: pre-line;
        }
    `}
`;

export const CoverageContainer = styled(Flex)<{ containerWidth: number }>`
  width: ${({ containerWidth = 1008 }) => `${containerWidth}px`};
  margin-left: 0;
  margin-right: 0;
  flex-direction: row;
  position: relative;

  ${CoverageItem} {
    flex-grow: 0;
    flex-shrink: 1;
  }

  ${MEDIA_QUERIES.mobile`
        overflow-x: auto;
        flex-shrink: 0;

        ${CoverageItem} {
            &:first-of-type {
                margin-left: 0;
            }

            &:last-of-type {
                margin-right: 0;
            }
        }
    `}

  ${MEDIA_QUERIES.upToDesktop`
        width: 100%;
    `}

    ${MEDIA_QUERIES.tabletAndDesktop`
        ${CoverageItem} {
            &:nth-of-type(n + 4) {
                margin-top: 90px;
            }
        }
    `}

    ${MEDIA_QUERIES.tablet`
        ${CoverageItem} {
            &:nth-of-type(n + 3) {
                margin-top: 90px;
            }
        }
    `}
`;

export const CoverageItemImage = styled(Image)`
  background-size: contain;
  min-width: 165px;
  height: 165px;
`;

export const CoverageItemInfo = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export const CoverageItemTitle = styled(Flex)`
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 11px;
  width: 100%;
`;

export const CoverageItemDescription = styled(Flex)`
  justify-content: center;
  text-wrap: balance;
`;

export const ModernCoverageItemTitle = styled(CoverageItemTitle)`
  margin-bottom: 0px;
`;
